import React from "react";
import { GridIcon } from "../../../atoms/icons/grid";
import ListIcon from "@mui/icons-material/Subject";
import { ListViewIcon } from "../../../atoms/icons/list-view";

export const ViewAs = ({ isGrid, setGrid }) => {
  return (
    <div className="view-as-wrapper">
      <div className="view-sort">View as:</div>
      <div className="view-icon-wrapper">
        <div
          className={`view-as ${isGrid ? "highlight" : ""}`}
          onClick={() => setGrid(true)}
        >
          <GridIcon fill={`${isGrid ? "black" : "white"}`} />
        </div>
        <div
          className={`view-as ${isGrid ? "" : "highlight"}`}
          onClick={() => setGrid(false)}
        >
          <ListViewIcon fill={`${isGrid ? "white" : "black"}`} />
        </div>
      </div>
    </div>
  );
};
